import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  getTransferDealershipName,
  isCarMax,
  isTransferDealership,
} from 'site-modules/shared/utils/dealer-details-utils';
import { DeliveryDetailsTooltip } from 'site-modules/shared/components/delivery-details-tooltip/delivery-details-tooltip';
import { isShowDeliveryDetails } from 'client/site-modules/shared/utils/is-show-delivery-details';
import { DELIVERY_SHIP_TEXT, DELIVERY_AVAILABLE, DELIVERY_CODES, HOME_DELIVERY_TYPE_TITLES } from './constants';
import { hasDeliveryRestrictions } from './helper';

/**
 * Returns ship text for National SRP and common SRP.
 * @param {string} deliveryCode
 * @param {string} zipCode
 * @param {string} stateCode
 * @param {boolean} isNational
 * @param {string} parentDealershipName
 * @returns {string}
 */
function getDeliveryShipText({ deliveryCode, zipCode, stateCode, isNational, parentDealershipName }) {
  if (isNational) {
    return `${DELIVERY_SHIP_TEXT[`${deliveryCode}_NTL`]}`;
  } else if (hasDeliveryRestrictions(stateCode)) {
    return DELIVERY_AVAILABLE;
  }
  if (isTransferDealership(parentDealershipName)) {
    const dealerName = getTransferDealershipName(parentDealershipName);
    return `${DELIVERY_SHIP_TEXT[`${deliveryCode}_LOCAL`]} ${dealerName}`;
  }
  if (isCarMax(parentDealershipName)) {
    return `${DELIVERY_SHIP_TEXT[deliveryCode]} ${zipCode}`;
  }
  return `${HOME_DELIVERY_TYPE_TITLES[deliveryCode]}`;
}

export function Delivery({
  isNational = false,
  deliveryCode = '',
  zipCode = '',
  classes = '',
  iconClasses = '',
  stateCode = '',
  parentDealershipName = '',
  isMobile = false,
  deliveryCost = 0,
  price = 0,
  iconStyle = {},
}) {
  if (!DELIVERY_CODES.includes(deliveryCode) || !zipCode) return null;
  const footnoteSymbol = '‡';
  const deliveryText = getDeliveryShipText({
    deliveryCode,
    zipCode,
    stateCode,
    isNational,
    parentDealershipName,
    deliveryCost,
  });

  const showDeliveryDetails = isShowDeliveryDetails({ parentDealershipName, deliveryCode });

  return (
    <div className={classnames('delivery d-inline-block px-0 pos-r text-gray-darker', classes)}>
      <span className={classnames('icon-transit me-0_5', iconClasses)} title="Shipping" style={iconStyle} />
      <span className="flex-shrink-0">
        {deliveryText}
        {!showDeliveryDetails && <sup>{footnoteSymbol}</sup>}
      </span>
      {showDeliveryDetails && (
        <>
          {' '}
          <DeliveryDetailsTooltip
            labelClassName={classnames({ xsmall: isMobile, small: !isMobile })}
            price={price}
            deliveryFee={deliveryCost}
            dealer={parentDealershipName}
          />
          <sup>{footnoteSymbol}</sup>
        </>
      )}
    </div>
  );
}

Delivery.propTypes = {
  deliveryCode: PropTypes.string,
  zipCode: PropTypes.string,
  stateCode: PropTypes.string,
  classes: PropTypes.string,
  iconClasses: PropTypes.string,
  isNational: PropTypes.bool,
  parentDealershipName: PropTypes.string,
  isMobile: PropTypes.bool,
  deliveryCost: PropTypes.number,
  price: PropTypes.number,
  iconStyle: PropTypes.shape({}),
};
